// One source of truth for an entity-reading element's binding: its stored
// options.context, resolved against the contexts the DC actually provides
// (root-option provides/requires). No class fallback — unbound or dangling is
// BROKEN, reported here so the builder paints the broken block and the compile
// step fails with an articulate error (DC + element + missing context). #166.
// An ancestor whose definition names this context in `providesSubtreeContext` supplies it
// (the Subscription Plan Sheet hands its subtree the selected plan).
export function isProvidedByAncestor(element, contextName) {
  const DynamicElementClass = element?.constructor;
  let parentId = element?.parentElementId;
  while (parentId && typeof DynamicElementClass?.get === "function") {
    const parent = DynamicElementClass.get(String(parentId));
    if (parent?.elementDef?.providesSubtreeContext === contextName) {
      return true;
    }
    parentId = parent?.parentElementId;
  }
  return false;
}

export function entityBindingProblems({ element, dynamicComponent } = {}) {
  const dcType = dynamicComponent?.type ?? "component";
  const declared = dynamicComponent?.availableContextsEntities ?? [];
  const declaredNames = declared.map(entry => entry?.name).filter(Boolean);
  const available = declaredNames.length ? declaredNames.join(", ") : "none";

  const binding = element?.parsedOptions?.context;
  const contextName = binding?.entityContext;

  if (!contextName) {
    return [
      "This element reads from an entity but is not bound to a context. "
      + `Bind it to a context this ${dcType} provides (${available}) — it will not render until bound.`,
    ];
  }
  if (!declaredNames.includes(contextName) && !isProvidedByAncestor(element, contextName)) {
    return [
      `Bound to the context "${contextName}", which this ${dcType} does not provide (provides: ${available}). `
      + "Re-point the binding in the inspector, or remove this element.",
    ];
  }
  return [];
}

export default entityBindingProblems;
